import { Grid, Container, Typography, Box } from "@mui/material";
import ProfileCard from "./ProfileCard";

function ProfileGrid({ profiles, onViewProfile, onAddToWishlist, pageType }) {
  const safeProfiles = Array.isArray(profiles) ? profiles : [];
  console.log("pageType", pageType);
  if (safeProfiles.length === 0) {
    return (
      <Container maxWidth="xl" sx={{ mt: 4 }}>
        <Typography align="center">No profiles found.</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl">
      <Grid container spacing={3} justifyContent={"flex-start"}>
        {safeProfiles.map((profile) => (
          <Grid
            sx={{
              display: "flex",
              width:
                pageType === "search"
                  ? { xs: "100%", sm: "47%", md: "47%", lg: "31%", xl: "31%" }
                  : { xs: "100%", sm: "47%", md: "47%", lg: "23%", xl: "23%" },
            }}
            key={profile.id}
          >
            <ProfileCard
              profile={profile}
              onViewProfile={onViewProfile}
              onAddToWishlist={onAddToWishlist}
              enquiryStatus={profile.enquiryStatus} // Pass status
              onSendEnquiry={profile.onSendEnquiry} // Pass handler
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default ProfileGrid;
